
(function () {
  if (window.woShippingTimerAssetInitialized) return;
  window.woShippingTimerAssetInitialized = true;
/*
 * WOSTORE shipping eligibility, for a warehouse in Valenciennes, France.
 * No DOM, network, storage, timers, dependencies, or visitor-time-zone reads.
 * Pass an explicit Date or epoch-millisecond number. Never parse a local date string.
 */

function wostoreFrenchPublicHolidays(year) {
  if (!Number.isInteger(year) || year < 1583 || year > 9999) {
    throw new RangeError('A Gregorian year between 1583 and 9999 is required.');
  }

  // Gregorian Easter: Meeus/Jones/Butcher computus.
  var a = year % 19;
  var b = Math.floor(year / 100);
  var c = year % 100;
  var d = Math.floor(b / 4);
  var e = b % 4;
  var f = Math.floor((b + 8) / 25);
  var g = Math.floor((b - f + 1) / 3);
  var h = (19 * a + b - d - g + 15) % 30;
  var i = Math.floor(c / 4);
  var k = c % 4;
  var l = (32 + 2 * e + 2 * i - h - k) % 7;
  var m = Math.floor((a + 11 * h + 22 * l) / 451);
  var month = Math.floor((h + l - 7 * m + 114) / 31);
  var day = ((h + l - 7 * m + 114) % 31) + 1;

  function afterEaster(days) {
    // UTC is used for calendar arithmetic only, avoiding DST shifts.
    return new Date(Date.UTC(year, month - 1, day + days)).toISOString().slice(0, 10);
  }

  return [
    year + '-01-01', // New Year's Day
    afterEaster(1), // Easter Monday
    year + '-05-01', // Labour Day
    year + '-05-08', // Victory Day
    afterEaster(39), // Ascension Thursday
    afterEaster(50), // Whit Monday
    year + '-07-14', // National Day
    year + '-08-15', // Assumption
    year + '-11-01', // All Saints' Day
    year + '-11-11', // Armistice Day
    year + '-12-25' // Christmas Day
  ].sort();
}

function wostoreShippingState(instant) {
  var state = {
    eligibleSameDay: false,
    secondsRemaining: 0,
    reason: 'invalid_instant',
    timeZone: 'Europe/Paris',
    parisDate: null,
    parisTime: null,
    weekday: null, // 0 = Sunday, 6 = Saturday
    cutoffTime: null,
    isPublicHoliday: null
  };

  var epoch = instant instanceof Date ? instant.getTime() : instant;
  if (typeof epoch !== 'number' || !Number.isFinite(epoch)) return state;
  var date = new Date(epoch);
  if (!Number.isFinite(date.getTime())) return state;

  var parts;
  try {
    parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Paris',
      calendar: 'gregory',
      numberingSystem: 'latn',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23'
    }).formatToParts(date);
  } catch (error) {
    state.reason = 'timezone_unavailable';
    return state;
  }

  var fields = {};
  parts.forEach(function (part) {
    if (part.type !== 'literal') fields[part.type] = part.value;
  });
  var year = Number(fields.year);
  var month = Number(fields.month);
  var day = Number(fields.day);
  var hour = Number(fields.hour);
  var minute = Number(fields.minute);
  var second = Number(fields.second);
  if (!Number.isInteger(year) || year < 1583 || year > 9999 ||
      !Number.isInteger(month) || month < 1 || month > 12 ||
      !Number.isInteger(day) || day < 1 || day > 31 ||
      !Number.isInteger(hour) || hour < 0 || hour > 23 ||
      !Number.isInteger(minute) || minute < 0 || minute > 59 ||
      !Number.isInteger(second) || second < 0 || second > 59) {
    state.reason = 'invalid_calendar';
    return state;
  }

  state.parisDate = fields.year + '-' + fields.month + '-' + fields.day;
  state.parisTime = fields.hour + ':' + fields.minute + ':' + fields.second;
  state.weekday = new Date(Date.UTC(year, month - 1, day)).getUTCDay();
  state.cutoffTime = state.weekday === 0 ? null : state.weekday === 6 ? '08:00' : '12:00';
  state.isPublicHoliday = wostoreFrenchPublicHolidays(year).indexOf(state.parisDate) !== -1;

  if (state.isPublicHoliday) {
    state.reason = 'public_holiday';
    return state;
  }
  if (state.weekday === 0) {
    state.reason = 'sunday';
    return state;
  }

  var cutoffSeconds = (state.weekday === 6 ? 8 : 12) * 60 * 60;
  var localSeconds = hour * 60 * 60 + minute * 60 + second + date.getUTCMilliseconds() / 1000;
  if (localSeconds >= cutoffSeconds) {
    state.reason = 'cutoff_reached';
    return state;
  }

  state.eligibleSameDay = true;
  // Round up so a valid final fraction of a second never displays an expired timer.
  state.secondsRemaining = Math.ceil(cutoffSeconds - localSeconds);
  state.reason = 'eligible_same_day';
  return state;
}


  function updateWoShippingTimers() {
    var elements = document.querySelectorAll('[data-wo-shipping-timer]');
    if (!elements.length) return;
    var state = wostoreShippingState(Date.now());
    elements.forEach(function (element) {
      element.hidden = !state.eligibleSameDay;
      element.setAttribute('data-wo-shipping-state', state.reason);
      var output = element.querySelector('[data-wo-shipping-countdown]');
      if (!output) return;
      if (!state.eligibleSameDay) {
        output.textContent = '';
        return;
      }
      var remaining = state.secondsRemaining;
      var hours = Math.floor(remaining / 3600);
      var minutes = Math.floor((remaining % 3600) / 60);
      var seconds = remaining % 60;
      output.textContent = hours + ' h ' + String(minutes).padStart(2, '0') + ' min ' + String(seconds).padStart(2, '0') + ' s';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateWoShippingTimers);
  else updateWoShippingTimers();
  document.addEventListener('shopify:section:load', updateWoShippingTimers);
  document.addEventListener('visibilitychange', updateWoShippingTimers);
  window.setInterval(function () { if (!document.hidden) updateWoShippingTimers(); }, 1000);
})();
